export type AccessLevelFilterEntry = {
  type: string;
  label: string;
  message: string;
};

export type AccessLevelFilterDisplay = {
  messageText: string;
  accessLevelCode: string;
  filterMessage: string;
};

const ACCESS_LEVEL_CODE_PATTERN = /^AL\d+$/i;

export const getAccessFilterFromFilters = (
  filters: unknown
): AccessLevelFilterEntry | null => {
  if (!Array.isArray(filters)) return null;

  const accessFilter = filters.find(
    (item): item is AccessLevelFilterEntry =>
      item?.type === 'access' &&
      typeof item?.label === 'string' &&
      ACCESS_LEVEL_CODE_PATTERN.test(item.label) &&
      typeof item?.message === 'string' &&
      item.message.trim().length > 0
  );

  return accessFilter ?? null;
};

const stripDisclaimerFromAnswer = (
  answer: string,
  disclaimerMessage: string,
  accessLevelCode: string
): string | null => {
  const normalizedDisclaimer = disclaimerMessage.trim();
  const candidates = [
    normalizedDisclaimer,
    normalizedDisclaimer.replace(/\.$/, ''),
    `${normalizedDisclaimer} ${accessLevelCode}`,
    `${normalizedDisclaimer.replace(/\.$/, '')} ${accessLevelCode}`,
  ];

  for (const candidate of candidates) {
    const index = answer.indexOf(candidate);
    if (index >= 0) {
      return answer.slice(0, index).trimEnd();
    }
  }

  return null;
};

export const resolveAccessLevelFilterDisplay = (
  answer: string | null | undefined,
  filters: unknown
): AccessLevelFilterDisplay | null => {
  const accessFilter = getAccessFilterFromFilters(filters);
  if (!accessFilter || !answer?.trim()) return null;

  const accessLevelCode = accessFilter.label.toUpperCase();
  const messageText = stripDisclaimerFromAnswer(
    answer,
    accessFilter.message,
    accessLevelCode
  );

  if (messageText == null) return null;

  return {
    messageText,
    accessLevelCode,
    filterMessage: accessFilter.message.trim(),
  };
};
